import { ACTION_TYPES, FIELD_KEYS } from 'app/developer-v3/constants';

const urlField = {
  [ACTION_TYPES.creates]: {
    label: 'Action Endpoint URL',
    key: FIELD_KEYS.url,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter the URL Zapier will send data with a POST call to find items from your app. Response must return an array of objects.',
  },
  [ACTION_TYPES.searches]: {
    label: 'Search Endpoint URL',
    key: FIELD_KEYS.url,
    type: 'single-line-string',
    required: true,
    helpText:
      'Enter the URL Zapier will send data with a GET call to find items from your app. Response must return an array of objects.',
  },
};

const inputFieldsUrlField = {
  [ACTION_TYPES.creates]: {
    label: 'Custom Acton Fields URL',
    key: FIELD_KEYS.inputFieldsUrl,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter a URL where Zapier can fetch custom fields to include in the action input form.',
  },
  [ACTION_TYPES.searches]: {
    label: 'Custom Search Fields URL',
    key: FIELD_KEYS.inputFieldsUrl,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter a URL where Zapier can fetch custom fields to include in the search action input form.',
  },
};

const outputFieldsUrlField = {
  [ACTION_TYPES.creates]: {
    label: 'Custom Action Result Fields URL',
    key: FIELD_KEYS.outputFieldsUrl,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter a URL where Zapier can fetch field names to format response data.',
  },
  [ACTION_TYPES.searches]: {
    label: 'Custom Search Result Fields URL',
    key: FIELD_KEYS.outputFieldsUrl,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter a URL where Zapier can fetch field names to format search response data.',
  },
};

const resourceUrlField = {
  [ACTION_TYPES.searches]: {
    label: 'Resource URL',
    key: FIELD_KEYS.resourceUrl,
    type: 'single-line-string',
    required: false,
    helpText:
      'Enter a URL where Zapier can send a GET request with a specific record ID. Should return the single object from that ID.',
  },
};

const formFields = {
  [ACTION_TYPES.creates]: [
    urlField[ACTION_TYPES.creates],
    inputFieldsUrlField[ACTION_TYPES.creates],
    outputFieldsUrlField[ACTION_TYPES.creates],
  ],
  [ACTION_TYPES.searches]: [
    urlField[ACTION_TYPES.searches],
    resourceUrlField[ACTION_TYPES.searches],
    inputFieldsUrlField[ACTION_TYPES.searches],
    outputFieldsUrlField[ACTION_TYPES.searches],
  ],
};

export default formFields;
